import { Box } from "@mui/material";
import type { JSX } from "react";

/**
 * The documentation sidebar's inline SVG icons, extracted from
 * `DocumentationSidebar.tsx`. All are presentational + `aria-hidden`.
 */

export function Chevron({ rotated }: { rotated: boolean }): JSX.Element {
  return (
    <Box
      component="svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      sx={{ width: 10, height: 10, transition: "transform 150ms", transform: rotated ? "rotate(90deg)" : "none" }}
    >
      <polyline points="9 18 15 12 9 6" />
    </Box>
  );
}

export function FolderIcon({ open }: { open: boolean }): JSX.Element {
  return (
    <Box
      component="svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      sx={{ width: 13, height: 13, color: "text.disabled", flexShrink: 0 }}
    >
      {open ? (
        <path d="M4 7h6l2 2h8v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1Z" />
      ) : (
        <path d="M3 7h6l2 2h10v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1Z" />
      )}
    </Box>
  );
}

export function EyeIcon(): JSX.Element {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

export function EyeOffIcon(): JSX.Element {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-6.5 0-10-7-10-7a18.4 18.4 0 0 1 4.06-5.04" />
      <path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c6.5 0 10 7 10 7a18.4 18.4 0 0 1-3.13 4.21" />
      <path d="m1 1 22 22" />
      <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
    </svg>
  );
}

export function PencilIcon(): JSX.Element {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4Z" />
    </svg>
  );
}

export function ReleaseDot({ focused }: { focused: boolean }): JSX.Element {
  return (
    <Box
      component="span"
      aria-hidden
      sx={{
        height: 6,
        width: 6,
        flexShrink: 0,
        borderRadius: "50%",
        bgcolor: focused ? "primary.main" : "text.disabled",
      }}
    />
  );
}
